var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.6667 10.75C104.624 10.7468 110.37 12.977 114.787 17.0068C119.204 21.0366 121.975 26.5779 122.563 32.553C123.15 38.5281 121.511 44.5097 117.965 49.3346C114.419 54.1594 109.219 57.4825 103.376 58.6574C106.083 65.1925 107.146 72.3001 106.471 79.3489C105.797 86.3977 103.405 93.1695 99.5089 99.0627C95.6129 104.956 90.3329 109.788 84.1381 113.13C77.9432 116.472 71.0253 118.221 63.9987 118.22C56.9721 118.22 50.0543 116.471 43.86 113.128C37.6656 109.785 32.3863 104.952 28.491 99.0579C24.5958 93.1641 22.2051 86.392 21.5314 79.3431C20.8578 72.2942 21.9219 65.1867 24.6293 58.652C18.7826 57.4831 13.5768 54.1628 10.026 49.3378C6.47507 44.5128 4.83328 38.5286 5.42033 32.5505C6.00737 26.5725 8.78123 21.0286 13.2017 16.9987C17.6221 12.9688 23.3727 10.7413 29.3333 10.75C35.4712 10.7504 41.3756 13.1207 45.8326 17.3736C50.2896 21.6265 52.9605 27.4388 53.296 33.6153C56.7923 32.7054 60.3891 32.2467 64 32.25C67.696 32.25 71.28 32.723 74.6987 33.6153C75.0343 27.4378 77.7059 21.6248 82.164 17.3718C86.6222 13.1187 92.5279 10.749 98.6667 10.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisney);
export default __webpack_public_path__ + "static/media/disney.f72fb22c0da7e22666f5bc530b4c1554.svg";
export { ForwardRef as ReactComponent };